import { render, staticRenderFns } from "./RegResult.vue?vue&type=template&id=287bee6c&scoped=true&"
import script from "./RegResult.vue?vue&type=script&lang=js&"
export * from "./RegResult.vue?vue&type=script&lang=js&"
import style0 from "./RegResult.vue?vue&type=style&index=0&id=287bee6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287bee6c",
  null
  
)

export default component.exports